export default __webpack_public_path__ + "static/media/G0670.34I-40934_-24242_0.1654023360000.36607a5b.jpg";